import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import style from "../styles/sidebar.module.css";
import { logout } from "../features/userSlice";
import useFetch from "../hooks/useFetch";
import { useTranslation } from "react-i18next";
import MiPerfil from "./Portals/MiPerfil";

function SideBar() {
  const { t } = useTranslation();
  const userInfo = useSelector((state) => state.user.info);
  const userStatus = useSelector((state) => state.user.status);
  const [mostrarPerfil, setMostrarPerfil] = useState(false);
  const nombreCompleto = userInfo ? `${userInfo.nombre} ${userInfo.apellido}` : null;
  const [currentPage, setCurrentPage] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const { error, execute } = useFetch();
  const dispatch = useDispatch();

  useEffect(() => {
    setCurrentPage(location.pathname);
    if (userStatus === "failed" && !userInfo) {
      navigate("/login");
    }
  }, [location, userInfo, userStatus, navigate]);

  async function handleLogout() {
    const apiURL = process.env.REACT_APP_API_URL || "https://api.systemicsurvey.com";
    const response = await execute(`${apiURL}/auth/logout`, "POST");
    if (response && response.status === 200) {
      dispatch(logout());
      navigate("/login");
    } else {
      console.error("Error al cerrar sesión:", error);
    }
  }

  return (
    <>
      <div className={style.sidebar}>
        <div className={style.infoPaginas}>
          <div className={style.infoEmpresa}>
            <img src='/img/systemic horizontal.svg' alt="Logo Empresa" />
          </div>
          <div className={style.paginas}>
            <Link
              to="/empresas"
              className={`${style.pagina} ${currentPage === "/empresas" ? `${style.activePage}` : ""}`}
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="#5f6368" className={currentPage === "/empresas" ? style.svgActivo : style.svgInactivo}><path d="M120-120v-560h160v-160h400v320h160v400H520v-160h-80v160H120Zm80-80h80v-80h-80v80Zm0-160h80v-80h-80v80Zm0-160h80v-80h-80v80Zm160 160h80v-80h-80v80Zm0-160h80v-80h-80v80Zm0-160h80v-80h-80v80Zm160 320h80v-80h-80v80Zm0-160h80v-80h-80v80Zm0-160h80v-80h-80v80Zm160 480h80v-80h-80v80Zm0-160h80v-80h-80v80Z" /></svg>
              <p className={currentPage === "/empresas" ? style.active : ''}>{t("sidebar-company")}</p>
            </Link>
            {/* Si es coach poner uno que ponga "Informes" */}
            {userInfo && userInfo.rol === "coach" && (
              <Link
                to="/datos"
                className={`${style.pagina} ${currentPage === "/datos" ? `${style.activePage} ${style.estadis}` : style.estadis}`}
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="#5f6368" className={currentPage === "/datos" ? style.svgActivo : style.svgInactivo}>
                  <path d="M480-120q-151 0-255.5-46.5T120-280v-400q0-66 105.5-113T480-840q149 0 254.5 47T840-680v400q0 67-104.5 113.5T480-120Zm0-479q89 0 179-25.5T760-679q-11-29-100.5-55T480-760q-91 0-178.5 25.5T200-679q14 30 101.5 55T480-599Zm0 199q42 0 81-4t74.5-11.5q35.5-7.5 67-18.5t57.5-25v-120q-26 14-57.5 25t-67 18.5Q600-528 561-524t-81 4q-42 0-82-4t-75.5-11.5Q287-543 256-554t-56-25v120q25 14 56 25t66.5 18.5Q358-408 398-404t82 4Zm0 200q46 0 93.5-7t87.5-18.5q40-11.5 67-26t32-29.5v-98q-26 14-57.5 25t-67 18.5Q600-328 561-324t-81 4q-42 0-82-4t-75.5-11.5Q287-343 256-354t-56-25v99q5 15 31.5 29t66.5 25.5q40 11.5 88 18.5t94 7Z" /></svg>
                <p className={currentPage === "/datos" ? style.active : ''}>{t("sidebar-database")}</p>
              </Link>
            )}
            {userInfo && userInfo.rol === "coach" && (
              <Link
                to="/facturacion"
                className={`${style.pagina} ${currentPage === "/facturacion" ? `${style.activePage} ${style.estadis}` : style.estadis}`}
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="#5f6368" className={currentPage === "/facturacion" ? style.svgActivo : style.svgInactivo}>
                  <path d="M200-80q-33 0-56.5-23.5T120-160v-640q0-33 23.5-56.5T200-880h560q33 0 56.5 23.5T840-800v640q0 33-23.5 56.5T760-80H200Zm0-80h560v-640H200v640Zm80-120h400v-80H280v80Zm0-160h400v-80H280v80Zm0-160h400v-80H280v80ZM200-800v640-640Z" />
                </svg>
                <p className={currentPage === "/facturacion" ? style.active : ''}>{t("sidebar-facturacion")}</p>
              </Link>
            )}
          </div>
        </div>
        <SidebarFooter
          logoutIcon="/img/sidebar/logout.svg"
          profileIcon={userInfo?.img_profile}
          name={nombreCompleto}
          userRole={userInfo?.rol}
        />
        {mostrarPerfil && <MiPerfil cerrarPopup={() => setMostrarPerfil(false)} />}
      </div>
      {/* Acciones adicionales y navegación solo para móvil */}
      <div className={style.bottomNavWrapper}>
        <div className={style.bottomNav}>
          <Link to="/empresas" className={`${style.bottomNavItem} ${location.pathname === "/empresas" ? style.active : ""}`}>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 -960 960 960"><path fill={location.pathname === "/empresas" ? "hsl(329, 84%, 48%)" : "#fff"} d="M120-120v-560h160v-160h400v320h160v400H520v-160h-80v160H120Zm80-80h80v-80h-80v80Zm0-160h80v-80h-80v80Zm0-160h80v-80h-80v80Zm160 160h80v-80h-80v80Zm0-160h80v-80h-80v80Zm0-160h80v-80h-80v80Zm160 320h80v-80h-80v80Zm0-160h80v-80h-80v80Zm0-160h80v-80h-80v80Zm160 480h80v-80h-80v80Zm0-160h80v-80h-80v80Z" /></svg>
            <span>Empresas</span>
          </Link>
          {/* Informes solo si es coach */}
          {userInfo && userInfo.rol === "coach" && (
            <Link to="/datos" className={`${style.bottomNavItem} ${location.pathname === "/datos" ? style.active : ""}`}>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 -960 960 960"><path fill={location.pathname === "/datos" ? "hsl(329, 84%, 48%)" : "#fff"} d="M480-120q-151 0-255.5-46.5T120-280v-400q0-66 105.5-113T480-840q149 0 254.5 47T840-680v400q0 67-104.5 113.5T480-120Zm0-479q89 0 179-25.5T760-679q-11-29-100.5-55T480-760q-91 0-178.5 25.5T200-679q14 30 101.5 55T480-599Zm0 199q42 0 81-4t74.5-11.5q35.5-7.5 67-18.5t57.5-25v-120q-26 14-57.5 25t-67 18.5Q600-528 561-524t-81 4q-42 0-82-4t-75.5-11.5Q287-543 256-554t-56-25v120q25 14 56 25t66.5 18.5Q358-408 398-404t82 4Zm0 200q46 0 93.5-7t87.5-18.5q40-11.5 67-26t32-29.5v-98q-26 14-57.5 25t-67 18.5Q600-328 561-324t-81 4q-42 0-82-4t-75.5-11.5Q287-343 256-354t-56-25v99q5 15 31.5 29t66.5 25.5q40 11.5 88 18.5t94 7Z" /></svg>
              <span>Informes</span>
            </Link>
          )}
          {userInfo && userInfo.rol === "coach" && (
            <Link to="/facturacion" className={`${style.bottomNavItem} ${location.pathname === "/facturacion" ? style.active : ""}`}>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 -960 960 960"><path fill={location.pathname === "/facturacion" ? "hsl(329, 84%, 48%)" : "#fff"} d="M200-80q-33 0-56.5-23.5T120-160v-640q0-33 23.5-56.5T200-880h560q33 0 56.5 23.5T840-800v640q0 33-23.5 56.5T760-80H200Zm0-80h560v-640H200v640Zm80-120h400v-80H280v80Zm0-160h400v-80H280v80Zm0-160h400v-80H280v80ZM200-800v640-640Z" /></svg>
              <span>{t("sidebar-facturacion")}</span>
            </Link>
          )}
          {/* Cerrar sesión */}
          <div className={style.bottomNavItem} onClick={handleLogout}>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 -960 960 960"><path fill={location.pathname === "/cambiar-empresa" ? "hsl(329, 84%, 48%)" : "#fff"} d="M224.615-160Q197-160 178.5-178.5 160-197 160-224.615v-510.77Q160-763 178.5-781.5 197-800 224.615-800h236.154q8.539 0 14.269 5.731 5.731 5.73 5.731 14.269 0 8.538-5.731 14.269-5.73 5.731-14.269 5.731H224.615q-9.23 0-16.923 7.692Q200-744.615 200-735.385v510.77q0 9.23 7.692 16.923Q215.385-200 224.615-200h236.154q8.539 0 14.269 5.731 5.731 5.731 5.731 14.269 0 8.539-5.731 14.269-5.73 5.731-14.269 5.731H224.615Zm497.769-300H387.692q-8.538 0-14.269-5.731-5.731-5.73-5.731-14.269t5.731-14.269Q379.154-500 387.692-500h334.692l-78.846-78.846q-5.615-5.616-6-13.539-.384-7.923 6-14.538 6.385-6.616 14.154-6.731 7.769-.116 14.385 6.5l104.539 104.539q9.692 9.692 9.692 22.615 0 12.923-9.692 22.615L672.077-352.846q-5.846 5.846-13.885 6.116-8.038.269-14.654-6.347-6.384-6.615-6.269-14.269.115-7.654 6.5-14.039L722.384-460Z" /></svg>
            <span>Cerrar sesión</span>
          </div>
        </div>
      </div>
    </>
  );
}

export default SideBar;

function SidebarFooter({ profileIcon, name, userRole }) {
  const { t } = useTranslation();
  const { error, execute } = useFetch();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [mostrarPerfil, setMostrarPerfil] = useState(false);

  const togglePerfil = () => {
    setMostrarPerfil(!mostrarPerfil);
  };

  async function handleLogout() {
    const apiURL = process.env.REACT_APP_API_URL || "https://api.systemicsurvey.com";
    const response = await execute(`${apiURL}/auth/logout`, "POST");
    if (response && response.status === 200) {
      dispatch(logout());
      navigate("/login");
    } else {
      console.error("Error al cerrar sesión:", error);
    }
  }

  return (
    <div className={style.footer}>
      <div className={style.perfil} id={style.mobileLogout} onClick={handleLogout}>
        <svg xmlns="http://www.w3.org/2000/svg" fill="#b2b2b2" viewBox="0 -960 960 960"><path d="M224.615-160Q197-160 178.5-178.5 160-197 160-224.615v-510.77Q160-763 178.5-781.5 197-800 224.615-800h236.154q8.539 0 14.269 5.731 5.731 5.73 5.731 14.269 0 8.538-5.731 14.269-5.73 5.731-14.269 5.731H224.615q-9.23 0-16.923 7.692Q200-744.615 200-735.385v510.77q0 9.23 7.692 16.923Q215.385-200 224.615-200h236.154q8.539 0 14.269 5.731 5.731 5.731 5.731 14.269 0 8.539-5.731 14.269-5.73 5.731-14.269 5.731H224.615Zm497.769-300H387.692q-8.538 0-14.269-5.731-5.731-5.73-5.731-14.269t5.731-14.269Q379.154-500 387.692-500h334.692l-78.846-78.846q-5.615-5.616-6-13.539-.384-7.923 6-14.538 6.385-6.616 14.154-6.731 7.769-.116 14.385 6.5l104.539 104.539q9.692 9.692 9.692 22.615 0 12.923-9.692 22.615L672.077-352.846q-5.846 5.846-13.885 6.116-8.038.269-14.654-6.347-6.384-6.615-6.269-14.269.115-7.654 6.5-14.039L722.384-460Z" /></svg>
        <Link onClick={handleLogout}>{t("sidebar-logout")}</Link>
      </div>

      {/* Renderizar imagen de perfil solo si el rol no es "responsable" */}
      <div className={style.perfil} onClick={togglePerfil}>
        {userRole !== "responsable" && (
          <img className={style.imgProfile} src={profileIcon} alt="" />
        )}
        <p className={style.miperfil}>{name}</p>
      </div>

      <div className={style.logosContainer}>
        <img className={style.logoInstitutoImg} src="/img/logoInstituto8color.png" alt="Logo Instituto 8" />
        <p className={style.poweredBy}>Powered by</p>
        <img className={style.logoLogin} src="/img/logo_largo.png" alt="Logo" />
      </div>

      {mostrarPerfil && <MiPerfil cerrarPopup={() => setMostrarPerfil(false)} />}
    </div>
  );
}
